module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    attrs: {
      "title": "Profit Loss Entry History",
      "size": "lg",
      "hide-footer": ""
    },
    on: {
      "shown": _vm.fetchHistory
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "text-center my-4"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "label": "Loading..."
    }
  })], 1) : _c('div', [(_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.historyData.length > 0) ? _c('div', {
    staticClass: "d-flex justify-content-end mb-2"
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "size": "sm"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o"
  }), _vm._v(" Export to Excel\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.historyData,
      "fields": _vm.fields,
      "striped": "",
      "hover": "",
      "responsive": "",
      "show-empty": ""
    },
    scopedSlots: _vm._u([{
      key: "createdCount",
      fn: function(data) {
        return [_c('span', {
          class: {
            'text-success font-weight-bold': data.value > 0
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "updatedCount",
      fn: function(data) {
        return [_c('span', {
          class: {
            'text-info font-weight-bold': data.value > 0
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }])
  }, [_c('template', {
    slot: "empty"
  }, [_c('div', {
    staticClass: "text-center text-muted my-2"
  }, [_vm._v("\n          No history records found for the current month.\n        ")])])], 2)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-751a749e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/profitLoss/ProfitLossHistoryModal.vue
// module id = 2752
// module chunks = 0